import { render, staticRenderFns } from "./AppTel.vue?vue&type=template&id=670e1cca&scoped=true"
import script from "./AppTel.vue?vue&type=script&lang=js"
export * from "./AppTel.vue?vue&type=script&lang=js"
import style0 from "./AppTel.vue?vue&type=style&index=0&id=670e1cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e1cca",
  null
  
)

export default component.exports